var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('md-button',{staticClass:"tag-button",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"icon"}),_c('span',{staticClass:"button-icon ml-1 mr-1 tag-button__icon"}),_c('md-tooltip',{staticClass:"article-actions",attrs:{"md-direction":"top"}},[_c('span',{staticClass:"small-hide"},[_vm._v("Tags")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }